import React,{useState} from 'react'
import "../assets/css/style.css"
import Header from './Header';
import {AiOutlineBars} from "react-icons/ai"
import { motion } from 'framer-motion';

const Bar = () => {
    const [open, setopen] = useState(false);
    const click = () =>{
      setopen(true);
      console.log("clicked");
    }
  return (
    <div id='bar'>
                <motion.div whileTap={{scale : 0.4}}
                onClick={click} className='bars-bg'><AiOutlineBars className='bars'/>
                </motion.div>
                {open && <Header closeModal={setopen} />}
    </div>
  )
}

export default Bar